import { Event } from '../Event'
import { ViewerContext } from '../../constants'

export interface PathPageSubmittedEventProperties {
  path_flow_id: string
  path_slug: string
  page_slug: string
}

export class PathPageSubmittedEvent extends Event<PathPageSubmittedEventProperties> {
  static displayName = 'Path Page Submitted'

  static allowedViewerContexts = [ViewerContext.Consumer]
}
